import { useTranslation } from "react-i18next";
import type { WhatsAppTemplatePresentation } from "@multi-chat/shared";
import { WhatsAppTemplatePreview } from "../../WhatsAppTemplatePreview/index.js";

export interface TemplateEditorPreviewPanelProps {
  presentation: WhatsAppTemplatePresentation;
  contentLanguage: string;
}

/**
 * Approved Step-2 preview surface (card + WhatsApp tint + bubble).
 * Shared by Create Step 2 and Step 3 so the visual output matches.
 */
export function TemplateEditorPreviewPanel({
  presentation,
  contentLanguage,
}: TemplateEditorPreviewPanelProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="grid gap-3 rounded-xl border border-line bg-surface p-4 shadow-sm">
      <div className="grid gap-0.5">
        <h3 className="m-0 text-sm font-semibold text-ink">
          {t("whatsapp.templates.manage.previewTitle")}
        </h3>
        <p className="m-0 text-xs leading-snug text-ink-muted">
          {t("whatsapp.templates.manage.previewHint")}
        </p>
      </div>
      <div className="grid min-h-80 content-center justify-items-center rounded-2xl border border-line bg-[color-mix(in_srgb,var(--color-surface-muted)_88%,var(--color-accent)_12%)] px-4 py-8">
        <div className="w-full max-w-[18rem]">
        <WhatsAppTemplatePreview
          presentation={presentation}
          contentLanguage={contentLanguage}
          collapseWhenMany
          seeAllLabel={t("whatsapp.templates.manage.wizard.editor.previewSeeAll")}
        />
        </div>
      </div>
    </div>
  );
}
